<template>
  <b-form-group
    label="Üretim Faaliyetleri"
    label-for="id_activity"
  >
    <v-select
      id="id_activity"
      v-model="filterData.id_activities"
      :options="activities"
      label="title"
      :reduce="item => item.id"
      placeholder="Seçiniz"
      multiple
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'Activities',
  components: {
    BFormGroup,
    vSelect,
  },
  computed: {
    filterData() {
      return this.$store.getters['customers/filterData']
    },
    activities() {
      return this.$store.getters['activities/dataList']
    },
  },
  created() {
    this.getSectors()
  },
  methods: {
    getSectors() {
      this.$store.dispatch('activities/getDataList', {
        select: [
          'activities.id AS id',
          'activities.title AS title',
        ],
      })
    },
  },
}
</script>
